(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-brine-product"]) return;
  try {
    
if(!customElements.get('brine-scroll-gallery')){
customElements.define('brine-scroll-gallery',class extends HTMLElement{
connectedCallback(){
this.controller=new AbortController();
const signal=this.controller.signal;
const track=this.querySelector('.brine-gallery-track'),slides=[...this.querySelectorAll('.brine-gallery-slide')],prev=this.querySelector('[data-gallery-prev]'),next=this.querySelector('[data-gallery-next]'),count=this.querySelector('[data-gallery-count]');
if(!slides.length)return;
let index=Math.max(0,slides.findIndex(s=>s.dataset.imageId===this.dataset.selected));
const current=()=>Math.max(0,Math.min(slides.length-1,Math.round(track.scrollLeft/Math.max(1,track.clientWidth))));
const sync=()=>{index=current();if(count)count.textContent=String(index+1);if(prev)prev.disabled=index===0;if(next)next.disabled=index===slides.length-1;};
const go=(i,animate=true)=>{index=Math.max(0,Math.min(slides.length-1,i));track.scrollTo({left:index*track.clientWidth,behavior:animate&&!matchMedia('(prefers-reduced-motion: reduce)').matches?'smooth':'instant'});};
prev?.addEventListener('click',()=>go(current()-1),{signal});
next?.addEventListener('click',()=>go(current()+1),{signal});
track.addEventListener('scroll',sync,{passive:true,signal});
track.addEventListener('keydown',e=>{if(!['ArrowLeft','ArrowRight','Home','End'].includes(e.key))return;e.preventDefault();go(e.key==='Home'?0:e.key==='End'?slides.length-1:current()+(e.key==='ArrowRight'?1:-1));},{signal});
const select=this.closest('[data-brine-product]').querySelector('[data-product-variant]');
select?.addEventListener('change',()=>{const i=slides.findIndex(s=>s.dataset.imageId===select.selectedOptions[0]?.dataset.imageId);if(i>=0)go(i);},{signal});
this.observer=new ResizeObserver(()=>{go(index,false);sync();});this.observer.observe(track);go(index,false);sync();
}
disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();}
});
}

  } catch(e) { console.error(e); }
})();
})();
